import React, { Fragment } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { getShortVideoRecom } from '../../../../services/api';
import { formatImage } from '@ifeng-fe/public_method';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { transformArr } from '../../../../utils/utils';
import { cookie } from '@ifeng-fe/ui_base';
import { userkeyUtil } from 'ThreeTerminal_utils';
import styles from './index.css';

class RelateVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        recomVideo: [],
    };

    async componentDidMount() {
        const { content } = this.props;
        let userkey = cookie.get('userkey');

        if (!userkey) {
            userkey = userkeyUtil.get(15);
        }
        let result = await getShortVideoRecom(content.base62Id, userkey);

        if (result && result.length > 0) {
            result = result.map((item) => {
                const goUrl = item?.link?.weburl;

                return {
                    title: item.title,
                    thumbnail: item.thumbnail && formatImage(item.thumbnail.replace(/\.webp|_webp/g, ''), 748, 1332),
                    url: goUrl || '',
                };
            });
            result = transformArr(result.slice(0, 6), 2);

            this.setState({
                recomVideo: result,
            });
        }
    }

    render() {
        const { recomVideo } = this.state;

        return (
            <div className={styles.relateVideo}>
                {recomVideo.map((itemOut, indexOut) => {
                    return (
                        <div key={indexOut} className={styles.relateVideoItem}>
                            {itemOut.map((itemIn, indexIn) => {
                                return (
                                    <Fragment key={indexIn}>
                                        <div className={styles.relateVideoBox}>
                                            <a href={itemIn.url}>
                                                <LazyImg className={styles.relateVideoPic} src={itemIn.thumbnail} />
                                                <div className={styles.relateVideoShadow}>
                                                    <div className={styles.relateVideoText}>{itemIn.title}</div>
                                                </div>
                                            </a>
                                        </div>
                                        {itemOut.length === 1 && <div className={styles.relateVideoBox} />}
                                    </Fragment>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default errorBoundary(RelateVideo);
